<template>
    <div class="splash" :class="{'splash_islogo': featureSplashLogoEnabled}">
        <div v-show="featureSplashLogoEnabled" class="splash__logo">
            <publisher-icon :icon-name="'IconAuthorization'" />
        </div>
        <loader />
    </div>
</template>

<script setup lang="ts">
    import { nextTick, onMounted } from "vue";
    import { ScreenName } from "@/common/types/screen-names";

    definePageMeta({ layout: 'default-no-header' });

    const { featureSplashLogoEnabled } = useAppConfig();
    const { $analytics } = useNuxtApp();

    onMounted(() => {
       void nextTick((): void => {
            $analytics.createScreenEvent(ScreenName.SPLASH_SCREEN, ScreenName.SPLASH_SCREEN);
        });
    });
</script>
